import { ContentfulLocale, isSysLink } from '@dcl/schemas';
import { getLocale } from '../translation';
import { isLoadingType } from '../loading';
import { FETCH_CAMPAIGN_REQUEST } from './actions';
const isLocalizedField = (value) => typeof value === 'object' && value !== null && 'en-US' in value;
export const getState = (state) => state.campaign;
export const getData = (state) => getState(state).data;
export const getLoading = (state) => getState(state).loading;
export const getError = (state) => getState(state).error;
export const isLoading = (state) => isLoadingType(getLoading(state), FETCH_CAMPAIGN_REQUEST);
export const getMainTag = (state) => getData(state)?.mainTag;
export const getCampaignName = (state) => getData(state)?.name || null;
export const getAdditionalTags = (state) => getData(state)?.additionalTags ?? [];
export const getAllTags = (state) => {
    const mainTag = getMainTag(state);
    const additionalTags = getAdditionalTags(state);
    return [mainTag, ...additionalTags].filter(Boolean);
};
export const getAssets = (state) => getData(state)?.assets || null;
export const getTabName = (state) => getData(state)?.tabName || null;
export const getBanner = (state, id) => {
    return getData(state)?.banners[id] ?? null;
};
export const getBannerAssets = (state, bannerId) => {
    const assets = getAssets(state);
    const banner = getBanner(state, bannerId);
    if (!banner)
        return {};
    return Object.entries(banner).reduce((acc, [_, value]) => {
        if (isLocalizedField(value)) {
            const usLocalizedValue = value['en-US'];
            if (isSysLink(usLocalizedValue)) {
                const asset = assets?.[usLocalizedValue.sys.id];
                if (asset) {
                    acc[usLocalizedValue.sys.id] = asset;
                }
            }
        }
        return acc;
    }, {});
};
export const getContentfulNormalizedLocale = (state) => {
    const storeLocale = getLocale(state);
    if (!['en', 'zh', 'es'].includes(storeLocale)) {
        return ContentfulLocale.enUS;
    }
    return storeLocale === 'en' ? ContentfulLocale.enUS : storeLocale;
};
//# sourceMappingURL=selectors.js.map